<script>
  import Formrow from "../shared/formrow.svelte"
  import {countries} from "./account-store.js"
  export let user = {}
  export let disabled = false
</script>

<Formrow label="Email" type="email" disabled={disabled} name="email" bind:value={user.email}></Formrow>
<Formrow label="Forename" type="text" disabled={disabled} name="first_name" bind:value={user.first_name}></Formrow>
<Formrow label="Surname" type="text" disabled={disabled} name="surname" bind:value={user.surname}></Formrow>
<Formrow label="Address" type="textarea" disabled={disabled} rows="4" name="address" bind:value={user.address}></Formrow>
<Formrow label="City" type="text" disabled={disabled} name="city" bind:value={user.city}></Formrow>
<Formrow label="Postcode" type="text" disabled={disabled} name="postcode" bind:value={user.postcode}></Formrow>
{#if user.country=="US"}
  <Formrow label="State" type="text" disabled={disabled} name="state" bind:value={user.state}></Formrow>
{/if}
<Formrow label="Country" type="select" disabled={disabled} name="country" bind:value={user.country}>
  <option value="">Please Select</option>
  {#each $countries as country}
    <option value={country.code} selected={country.code==user.country}>{country.name}</option>
  {/each}
</Formrow>
<Formrow label="Telephone" type="text" disabled={disabled} name="telephone" bind:value={user.phone1}></Formrow>
<Formrow label="Mobile" type="text" disabled={disabled} name="mobile" bind:value={user.phone2}></Formrow>